/* eslint-disable no-cond-assign */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { getTrustArcConsent } from '../utils/getTrustArcConsent';

const CHECK_EVERY_MILLISECONDS = 1000;
const MAXIMUM_TIMES_CHECKED = 100;
const PRIVACY_MANAGER_ACTION = {
  getConsent: 'getConsent',
  submitPreferences: 'submit_preferences',
};
const PRIVACY_MANAGER_API_NAME = {
  getConsent: 'getConsent',
  getConsentDecision: 'getConsentDecision',
  getGDPRConsentDecision: 'getGDPRConsentDecision',
  getConsentCategories: 'getConsentCategories',
};
const SOURCE_DECISION = {
  implied: 'implied',
  asserted: 'asserted',
};

const defaultValues = {
  trustArcConsent: [0],
};

export const TrustArcContext = React.createContext(defaultValues);

export const useTrustArc = () => {
  const context = useContext(TrustArcContext);
  if (!context) {
    throw new Error('useTrustArc must be used within the TrustArcProvider');
  }

  return context;
};

const TrustArcProvider = ({ children }) => {
  const [trustArcConsent, setTrustArcConsent] = useState(getTrustArcConsent);

  useEffect(() => {
    /**
     * Register with the TrustArc API to receive callbacks when a preference update occurs
     * You must wait for the TrustArc API (PrivacyManagerAPI object) to exist on the page before registering
     */
    let attempts = 0;
    const interval = setInterval(() => {
      if (window.PrivacyManagerAPI) {
        const apiObject = {
          PrivacyManagerAPI: {
            action: PRIVACY_MANAGER_ACTION.getConsent,
            timestamp: Date.now(),
            self: self.location.host,
          },
        };
        self.top.postMessage(JSON.stringify(apiObject), '*');
        clearInterval(interval);
      }

      attempts += 1;
      if (attempts > MAXIMUM_TIMES_CHECKED) clearInterval(interval);
    }, CHECK_EVERY_MILLISECONDS);

    /**
     * Callbacks will occur in the form of a PostMessage event.
     * This code listens for the appropriately formatted PostMessage event
     */
    const messageHandler = (event) => {
      try {
        const eventData = JSON.parse(event.data);
        const decision = _.get(eventData, 'PrivacyManagerAPI');

        if (decision) {
          if (decision.action === PRIVACY_MANAGER_ACTION.getConsent) {
            const { consentDecision, source } = window.PrivacyManagerAPI.callApi(
              PRIVACY_MANAGER_API_NAME.getGDPRConsentDecision,
              decision.self,
            );

            if (source === SOURCE_DECISION.implied) {
              self.truste?.bn?.openBanner();
            }

            setTrustArcConsent(consentDecision);
          }
        }
      } catch (xx) {
        /** not a cm api message **/
      }
    };

    self.addEventListener('message', messageHandler);

    return () => {
      self.removeEventListener('message', messageHandler);
    };
  }, []);

  return (
    <TrustArcContext.Provider
      value={{
        ...defaultValues,
        trustArcConsent,
      }}
    >
      {children}
    </TrustArcContext.Provider>
  );
};

export default TrustArcProvider;
